import { render } from "./QuickpayDeadlines.vue?vue&type=template&id=1e70f8d6&scoped=true"
import script from "./QuickpayDeadlines.vue?vue&type=script&lang=js"
export * from "./QuickpayDeadlines.vue?vue&type=script&lang=js"

import "./QuickpayDeadlines.vue?vue&type=style&index=0&id=1e70f8d6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e70f8d6"]])

export default __exports__